import {
  Box,
  Button,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Paper,
  Select,
  TextField,
  FormControl,
  FormControlLabel,
  Switch,
} from "@material-ui/core";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import { useFormik } from "formik";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import { LogsDialog } from "pages/admin/setting/EmployeePage";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SignaturePad from "react-signature-canvas";
import { getRoleList } from "redux/modules/roleSlice";
import { useHistory } from "react-router-dom";

import {
  getEmployeeDetail,
  updateEmployee,
  Addemployee,
} from "redux/modules/employeeSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import * as yup from "yup";
import FileService from "services/FileService";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import mime from "mime";
import { RoleId } from "libs/configs/constant";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import HttpClient from "libs/utils/HttpClient";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  content: {
    marginTop: 30,
  },
  warpSubHeader: {
    marginTop: 20,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  wrapContent: {
    marginTop: 30,
  },
  sigPad: { width: "100%", height: "100%" },
  buttons: { width: "100%", height: "30px" },
  wrapSig: {
    padding: "10px",
    border: "1px solid lightgray",
    borderRadius: "10px",
    textAlign: "center",
  },
  sigImage: {
    backgroundSize: "200px 50px",
    width: "80%",
    height: "80%",
    backgroundColor: "white",
    borderRadius: 15,
  },
  wrapField: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },

  textField: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    marginTop: 8,
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: theme.palette.grey[100],
    },
  },
  wrapContoller: {
    display: "flex",
  },
  formControl: {
    width: "100%",
  },
  warpFormControl: {
    paddingLeft: 10,
    paddingRight: 10,
    marginTop: 10,
  },
}));

function EmployeeDetailPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const sigPad = useRef({});
  const params = useParams();
  const empId = get(params, "empId", "") || "";
  const [open, setOpen] = React.useState(false);
  const [dialogData, setDialogData] = React.useState({});
  const [signDataUri, setSignDataUri] = useState(null);
  const [signDataID, setSignDataID] = useState("");
  const { detail: empDetail } = useSelector((state) => state.employee);
  const { list: roleList, isLoading } = useSelector((state) => state.role);
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const { profile } = useSelector((state) => state.user);
  const masterData = useSelector(selectMasterData);
  const department = get(masterData, "department", []);
  const history = useHistory();

  useEffect(async () => {
    await dispatch(getRoleList());

    await dispatch(
      getMasterData({
        department: true,
      })
    );

    if (empId) {
      await dispatch(getEmployeeDetail(empId));
    }
  }, [empId]);

  useEffect(async () => {
    if (empDetail?.signatureFileID) {
      const data = await FileService.getFile(empDetail?.signatureFileID);
      try {
        const fileName = empDetail.filename + empDetail.ext;
        const blobFile = new File([data], fileName, {
          type: mime.getType(empDetail.ext),
        });

        console.log(URL.createObjectURL(blobFile));
        setSignDataUri(URL.createObjectURL(blobFile));
      } catch (error) {
        console.error(error);
      }
    }
  }, [empDetail]);

  const handleClose = async (value) => {
    setOpen(false);
  };

  const clear = () => {
    sigPad.current.clear();
    setSignDataUri(null);
  };
  const trim = async () => {
    // setSignDataUri(sigPad.current.getTrimmedCanvas().toDataURL('image/png'))
    showAdminLoading();

    const sigFile = sigPad.current.getTrimmedCanvas().toDataURL("image/png");
    const filesignDataUri = await fetch(sigFile)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "signImg.png", { type: "image/png" });
        return file;
      });

    const resSign = await FileService.uploadFile({
      file: filesignDataUri,
      Status: true,
    });

    if (empId) {
      if (resSign.status) {
        const signFileId = resSign.results?.fileID;
        const body = {
          empId: empId,
          departmentId: empDetail?.departmentId,
          email: empDetail?.email,
          employeeNo: empDetail?.employeeNo,
          employeeFistName: empDetail?.employeeFistName,
          employeeLastName: empDetail?.employeeLastName,
          position: empDetail?.position,
          roleId: empDetail?.roleId,
          signatureFileID: signFileId,
          status: empDetail?.status,
        };
        await dispatch(updateEmployee(body));
      }
    } else {
      if (resSign.status) {
        const signFileId = resSign.results?.fileID;
        setSignDataID(signFileId);
      }
    }

    hideAdminLoading();
  };

  const validationSchema = yup.object({
    // date: yup.date().required("Date is required."),
    employeeFistName: yup.string().trim().required("First name is required."),
    employeeLastName: yup.string().trim().required("Last name is required."),
    email: yup.string().trim().required("Email is required."),
    position: yup.string().trim().required("Position is required."),
    roleId: yup.string().ensure().trim().required("Role is required."),
    username: yup.string().ensure().trim().required("Username is required."),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      email: empDetail?.email ? empDetail?.email : "",
      employeeFistName: empDetail?.employeeFistName
        ? empDetail?.employeeFistName
        : "",
      employeeFistNameTH: empDetail?.employeeFistNameTH
        ? empDetail?.employeeFistNameTH
        : "",
      employeeLastName: empDetail?.employeeLastName
        ? empDetail?.employeeLastName
        : "",
      employeeLastNameTH: empDetail?.employeeLastNameTH
        ? empDetail?.employeeLastNameTH
        : "",
      titleEN: empDetail?.titleEN ? empDetail?.titleEN : "",
      titleTH: empDetail?.titleTH ? empDetail?.titleTH : "",
      position: empDetail?.position ? empDetail?.position : "",
      positionTH: empDetail?.positionTH ? empDetail?.positionTH : "",
      roleId: empDetail?.roleId ? empDetail?.roleId : "",
      departmentName: empDetail?.departmentName
        ? empDetail?.departmentName
        : "",
      departmentId: empDetail?.departmentId ? empDetail?.departmentId : "",
      username: empDetail?.username ? empDetail?.username : "",
      password: empDetail?.password ? empDetail?.password : "",
      pinPassword: empDetail?.pinPassword ? empDetail?.pinPassword : "",
      mobile: empDetail?.mobile ? empDetail?.mobile : "",
      isNotiEmail: empDetail?.isNotiEmail ? true : false,
    },
    onSubmit: async (c) => {
      if (empId) {
        showAdminLoading();
        if (empDetail?.signatureFileID !== "") {
          try {
            const response = await HttpClient.post(
              "/api/users/username/check",
              {
                username: c?.username,
              }
            );
            // When Username Checked
            if (
              response.results.check ||
              c?.username === empDetail?.username ||
              empDetail?.username === null
            ) {
              if (c?.password !== "") {
                const body = {
                  empId: empId,
                  departmentId: empDetail?.departmentId
                    ? empDetail?.departmentId
                    : c?.departmentId,
                  email: c?.email,
                  mobile: c?.mobile,
                  employeeNo: empDetail?.employeeNo,
                  employeeFistName: c?.employeeFistName,
                  employeeLastName: c?.employeeLastName,
                  EmployeeFistNameTH: c?.employeeFistNameTH,
                  EmployeeLastNameTH: c?.employeeLastNameTH,
                  titleEN: c?.titleEN,
                  titleTH: c?.titleTH,
                  PositionTH: c?.positionTH,
                  position: c?.position,
                  roleId: c?.roleId,
                  signatureFileID: empDetail?.signatureFileID,
                  pinPassword: null,
                  username: c?.username,
                  password: c?.password,
                  isNotiEmail: c?.isNotiEmail,
                  status: empDetail?.status,
                };
                await dispatch(updateEmployee(body));
                alert("สำเร็จ");
                hideAdminLoading();
              } else {
                const body = {
                  empId: empId,
                  departmentId: empDetail?.departmentId
                    ? empDetail?.departmentId
                    : c?.departmentId,
                  email: c?.email,
                  mobile: c?.mobile,
                  employeeNo: empDetail?.employeeNo,
                  employeeFistName: c?.employeeFistName,
                  employeeLastName: c?.employeeLastName,
                  EmployeeFistNameTH: c?.employeeFistNameTH,
                  EmployeeLastNameTH: c?.employeeLastNameTH,
                  titleEN: c?.titleEN,
                  titleTH: c?.titleTH,
                  PositionTH: c?.positionTH,
                  position: c?.position,
                  roleId: c?.roleId,
                  signatureFileID: empDetail?.signatureFileID,
                  pinPassword: null,
                  username: c?.username,
                  isNotiEmail: c?.isNotiEmail,
                  status: empDetail?.status,
                };
                await dispatch(updateEmployee(body));
                alert("สำเร็จ");
                hideAdminLoading();
              }
            } else {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "error",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "User Already !",
                  "Please Change Username !",
                  "error"
                );
              });
              hideAdminLoading();
            }
            if (response.status) return response;
            return Promise.reject(response);
          } catch (error) {
            const newError = error;
            throw newError;
          }
        } else {
          alert("กรุณาเขียนลายเซ็นต์");
          hideAdminLoading();
        }
      } else {
        if (signDataID !== "") {
          const body = {
            empId: null,
            departmentId: c?.departmentId,
            email: c?.email,
            mobile: c?.mobile,
            employeeFistName: c?.employeeFistName,
            employeeLastName: c?.employeeLastName,
            EmployeeFistNameTH: c?.employeeFistNameTH,
            EmployeeLastNameTH: c?.employeeLastNameTH,
            titleEN: c?.titleEN,
            titleTH: c?.titleTH,
            PositionTH: c?.positionTH,
            position: c?.position,
            pinPassword: c?.pinPassword,
            roleId: c?.roleId,
            signatureFileID: signDataID,
            username: c?.username,
            password: c?.password,
            isNotiEmail: c?.isNotiEmail,
            status: true,
          };

          try {
            const response = await HttpClient.post(
              "/api/users/username/check",
              {
                username: c?.username,
              }
            );
            if (response.results.check) {
              if (dispatch(Addemployee(body))) {
                history.push("/admin/setting/manage-user");
              }
            }
            // When Username Checked
            // if (response.results.check) {
            //   try {
            //     const response_email = await HttpClient.post(
            //       "/api/users/email/check",
            //       {
            //         email: c?.email,
            //       }
            //     );
            //     //When Email Check Success
            //     if (response_email.results.check) {
            //       console.log(body);

            //     } else {
            //       const MySwal = withReactContent(Swal);

            //       MySwal.fire({
            //         icon: "error",
            //         didOpen: () => {
            //           MySwal.clickConfirm();
            //         },
            //       }).then(() => {
            //         return MySwal.fire(
            //           "Email Already !",
            //           "Please Change Email !",
            //           "error"
            //         );
            //       });
            //     }
            //     if (response_email.status) return response_email;
            //     return Promise.reject(response_email);
            //   } catch (error) {
            //     const newError = error;
            //     throw newError;
            //   }
            else {
              const MySwal = withReactContent(Swal);

              MySwal.fire({
                icon: "error",
                didOpen: () => {
                  MySwal.clickConfirm();
                },
              }).then(() => {
                return MySwal.fire(
                  "User Already !",
                  "Please Change Username !",
                  "error"
                );
              });
            }
            if (response.status) return response;
            return Promise.reject(response);
          } catch (error) {
            const newError = error;
            throw newError;
          }
        } else {
          alert("กรุณาเขียนลายเซ็นต์");
        }
      }
    },
  });

  useEffect(async () => {
    if (formik) {
      formik.setFieldValue("roleId", empDetail?.roleId);
    }
  }, [roleList, empDetail?.roleId]);

  return (
    <Paper className={classes.paper}>
      <AdminTitle title="Setting" subTitle="Employee" />

      <LogsDialog data={dialogData} open={open} onClose={handleClose} />
      <form onSubmit={formik.handleSubmit} id="emp-form">
        <div className={classes.warpSubHeader}>
          <AdminTitle2 subTitle="Employee Informations" />
          <div className={classes.wrapContoller}>
            {empId ? (
              <Button
                variant="outlined"
                size="medium"
                color="primary"
                style={{ marginRight: 10 }}
                type="button"
                onClick={() => {
                  setDialogData({ empId: empId });
                  setOpen(true);
                }}
                className={classes.buttonDialogSave}
              >
                Logs
              </Button>
            ) : null}
            <Button
              variant="contained"
              size="medium"
              color="primary"
              type="submit"
              onClick={() => {}}
              className={classes.buttonDialogSave}
            >
              Save
            </Button>
          </div>
        </div>

        <div className={classes.wrapContent}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Title</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="titleEN"
                  multiline
                  value={formik.values.titleEN}
                  onChange={formik.handleChange}
                  onBlur={formik.handleChange}
                  error={isError("titleEN", formik)}
                  helperText={getErrorMessage("titleEN", formik)}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>คำนำหน้า</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="titleTH"
                  multiline
                  value={formik.values.titleTH}
                  onChange={formik.handleChange}
                  onBlur={formik.handleChange}
                  error={isError("titleTH", formik)}
                  helperText={getErrorMessage("titleTH", formik)}
                />
              </div>
            </Grid>
            <Box width="100%" />

            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>First Name</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="employeeFistName"
                  value={formik.values.employeeFistName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("employeeFistName", formik)}
                  helperText={getErrorMessage("employeeFistName", formik)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Last Name</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="employeeLastName"
                  value={formik.values.employeeLastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("employeeLastName", formik)}
                  helperText={getErrorMessage("employeeLastName", formik)}
                />
              </div>
            </Grid>
            <Box width="100%" />
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>ชื่อ</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="employeeFistNameTH"
                  value={formik.values.employeeFistNameTH}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("employeeFistNameTH", formik)}
                  helperText={getErrorMessage("employeeFistNameTH", formik)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>นามสกุล</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="employeeLastNameTH"
                  value={formik.values.employeeLastNameTH}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("employeeLastNameTH", formik)}
                  helperText={getErrorMessage("employeeLastNameTH", formik)}
                />
              </div>
            </Grid>

            <Box width="100%" />
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Position</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="position"
                  multiline
                  value={formik.values.position}
                  onChange={formik.handleChange}
                  onBlur={formik.handleChange}
                  error={isError("position", formik)}
                  helperText={getErrorMessage("position", formik)}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>ตำแหน่ง</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="positionTH"
                  multiline
                  value={formik.values.positionTH}
                  onChange={formik.handleChange}
                  onBlur={formik.handleChange}
                  error={isError("positionTH", formik)}
                  helperText={getErrorMessage("positionTH", formik)}
                />
              </div>
            </Grid>
            <Box width="100%" />

            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Role</InputLabel>
                <Select
                  id="roleId"
                  name="roleId"
                  disabled={
                    !(
                      profile?.roleId === RoleId.Director ||
                      profile?.roleId === RoleId.Admin
                    )
                  }
                  className={classes.textField}
                  variant="outlined"
                  value={formik.values.roleId}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {!empId ? (
                    <MenuItem selected disabled value="">
                      กรุณาเลือกตำแหน่ง
                    </MenuItem>
                  ) : null}

                  {roleList
                    .filter(
                      (x) =>
                        x.status === "Y" && x.roleLevel >= 2 && x.roleLevel <= 5
                    )
                    .map((row) => (
                      <MenuItem value={row.roleId} key={row.roleId}>
                        {row.roleName}
                      </MenuItem>
                    ))}
                </Select>
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Department</InputLabel>
                <FormControl variant="outlined" className={classes.textField}>
                  <Select
                    value={formik.values.departmentId}
                    name="departmentId"
                    onChange={formik.handleChange}
                    onBlur={formik.handleChange}
                    error={isError("departmentId", formik)}
                    helperText={getErrorMessage("departmentId", formik)}
                    disabled={
                      !(
                        profile?.roleId === RoleId.Director ||
                        profile?.roleId === RoleId.Admin
                      )
                    }
                  >
                    {department.map((config) => (
                      <MenuItem
                        key={config.departmentId}
                        value={config.departmentId}
                      >
                        {config.departmentName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </Grid>
            <Box width="100%" />
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Email</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleChange}
                  error={isError("email", formik)}
                  helperText={getErrorMessage("email", formik)}
                />
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Mobile</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="mobile"
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("mobile", formik)}
                  helperText={getErrorMessage("mobile", formik)}
                />
              </div>
            </Grid>
            <Box width="100%" />
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Username</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="username"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("username", formik)}
                  helperText={getErrorMessage("username", formik)}
                  inputProps={{
                    autocomplete: "new-password",
                    form: {
                      autocomplete: "off",
                    },
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>Password</InputLabel>
                <TextField
                  variant="outlined"
                  className={classes.textField}
                  name="password"
                  type="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("password", formik)}
                  helperText={getErrorMessage("password", formik)}
                  inputProps={{
                    autocomplete: "new-password",
                    form: {
                      autocomplete: "off",
                    },
                  }}
                />
              </div>
            </Grid>
            <Box width="100%" />

            <Grid item xs={12} md={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={formik?.values?.isNotiEmail ? true : false}
                    name="isNotiEmail"
                    value={formik.values.isNotiEmail}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                }
                label="รับ Email การแจ้งเตือน"
              />
            </Grid>
            {/* <Grid item xs={12} md={4}>
              <div className={classes.wrapField}>
                <InputLabel>PinPassword</InputLabel>
                <TextField
                  variant="outlined"
                  inputProps={{ maxLength: 4, max: 4 }}
                  className={classes.textField}
                  name="pinPassword"
                  value={formik.values.pinPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={isError("pinPassword", formik)}
                  helperText={getErrorMessage("pinPassword", formik)}
                />
              </div>
            </Grid> */}

            <Box width="100%" style={{ marginTop: 15 }} />
            <Grid item xs={12} md={8}>
              <div className={classes.sigContainer}>
                {!signDataUri && (
                  <div
                    style={{
                      border: "1px solid darkgray",
                      borderRadius: "15px",
                    }}
                  >
                    <SignaturePad
                      canvasProps={{ className: classes.sigPad }}
                      ref={sigPad}
                    />
                  </div>
                )}
                {signDataUri ? (
                  <div className={classes.wrapSig}>
                    <img className={classes.sigImage} src={signDataUri} />
                  </div>
                ) : null}
              </div>
            </Grid>
            <Grid item xs={12} md={3}>
              {signDataUri && (
                <>
                  <div style={{ marginBottom: 15 }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      type="button"
                      onClick={() => {
                        setSignDataUri(null);
                      }}
                      className={classes.buttonViewDetail}
                    >
                      New Signature
                    </Button>
                  </div>
                </>
              )}
              {!signDataUri && (
                <>
                  <div style={{ marginBottom: 15 }}>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={clear}
                      type="button"
                      className={classes.buttonViewDetail}
                    >
                      Clear
                    </Button>
                  </div>
                  <div>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="button"
                      onClick={() => {
                        trim();
                      }}
                      className={classes.buttonViewDetail}
                    >
                      OK
                    </Button>
                  </div>
                </>
              )}
            </Grid>
          </Grid>
        </div>
      </form>
    </Paper>
  );
}

export default EmployeeDetailPage;
